/* Generated from Java with JSweet 2.3.7 - http://www.jsweet.org */
import { ExtensibleNode } from '../ExtensibleNode';
import { IVisitor } from '../../visitors/IVisitor';

/**
 * Constructor.
 * @class
 * @extends ExtensibleNode
 * @author eric.wittmann@gmail.com
 */
export abstract class Contact extends ExtensibleNode {
    public name : string;

    public url : string;

    public email : string;

    public constructor() {
        super();
        if(this.name===undefined) this.name = null;
        if(this.url===undefined) this.url = null;
        if(this.email===undefined) this.email = null;
    }

    /**
     * @see io.apicurio.datamodels.core.models.Node#accept(io.apicurio.datamodels.core.visitors.IVisitor)
     * @param {*} visitor
     */
    public accept(visitor : IVisitor) {
        visitor.visitContact(this);
    }
}
Contact["__class"] = "io.apicurio.datamodels.core.models.common.Contact";
Contact["__interfaces"] = ["io.apicurio.datamodels.core.models.IVisitable"];




